import { HtmlPreviewSheet } from '@trellis/roots/overlays'

import { useQuotePreviewQuery } from '@/hooks'

export function QuotePreviewSheet({
  quoteId,
  onOpenChange,
}: {
  quoteId: string | null
  onOpenChange: (isOpen: boolean) => void
}) {
  const { data: previewResult } = useQuotePreviewQuery(quoteId)

  return (
    <HtmlPreviewSheet
      open={quoteId !== null}
      onOpenChange={onOpenChange}
      title="Quote preview"
      description="Preview of the quote as a PDF."
      html={previewResult?.data}
    />
  )
}
